import { createFileRoute } from "@tanstack/react-router";

import RewardPanel, { RewardPanelSection } from "@/components/Loyalty/RewardPanel";

const Component = () => {
  const { rewardUuid } = Route.useParams();
  const { section } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RewardPanel
      rewardUuid={rewardUuid}
      section={section}
      onSectionChange={(next) =>
        navigate({
          search: next === "details" ? { section: next } : {},
          replace: true,
        })
      }
    />
  );
};

// Stock is open unless the URL says details.
export const Route = createFileRoute("/gym/$venueUuid/loyalty/rewards/$rewardUuid")({
  validateSearch: (search: Record<string, unknown>): { section?: RewardPanelSection } =>
    search.section === "details" ? { section: "details" } : {},
  component: Component,
});
